import api from './api';

export const equityDashboardAPI = {
  getZoneComparison: (params?: { academic_year?: string }) =>
    api.get('/sis-integration/equity/zone-comparison/', { params }),

  getDistrictDetails: (params?: { academic_year?: string }) =>
    api.get('/sis-integration/equity/district-details/', { params }),
};
